<template>
  <el-row class="receipt-tippie-feedback mt-30">
    <el-col>
      <img
        src="@/assets/img/logo.png"
        alt="Tippie Logo"
      >
      <h2 v-if="showWarning">
        {{ $t("receipt.redirect-warning") }}
      </h2>
      <p class="mt-30">
        {{ $t("receipt.follow-us") }}
      </p>
    </el-col>
    <el-col>
      <div class="social-items">
        <a
          target="_blank"
          href="https://www.instagram.com/tippie.pay/"
          class="social-item"
        >
          <img
            src="@/assets/img/social/instagram.svg"
            alt="Instagram"
          >
        </a>
        <a
          target="_blank"
          href="https://www.facebook.com/tippie.pay"
          class="social-item"
        >
          <img
            src="@/assets/img/social/facebook.svg"
            alt="Facebook"
          >
        </a>
        <a
          target="_blank"
          href="https://www.google.com/maps/place//data=!4m3!3m2!1s0x805c01ba07835ce9:0xf5d33174631d2bbe!12e1?source=g.page.m.ia._&laa=nmx-review-solicitation-ia2"
          class="social-item"
        >
          <img
            src="@/assets/img/social/google.svg"
            alt="Google Review"
          >
        </a>
        <a
          target="_blank"
          href="https://www.linkedin.com/company/tippie"
          class="social-item"
        >
          <img
            src="@/assets/img/social/linkedin.svg"
            alt="LinkedIn"
          >
        </a>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "ReceiptFeedback",
  props: {
    showWarning: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.receipt-tippie-feedback {
  h2 {
    color: #000;
    font-weight: bold;
  }
  text-align: center;
  img {
    margin: 0 auto;
    display: block;
    width: 80px;
  }

  .social-items {
    margin: 30px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    .social-item {
      height: 48px;
      width: 48px;

      img {
        max-width: 100%;
        width: 48px;
      }
    }
  }
}
</style>
